import { Progress } from "@base-ui-components/react/progress";
import { ComponentProps } from "react";
import { cn } from "../../utils/helpers";

export function Root({
    children,
    ...props
}: ComponentProps<typeof Progress.Root>) {
    return <Progress.Root {...props}>{children}</Progress.Root>;
}

export function Label({
    children,
    ...props
}: ComponentProps<typeof Progress.Label>) {
    return (
        <Progress.Label
            className="text-caption text-textSec font-medium"
            {...props}
        >
            {children}
        </Progress.Label>
    );
}

export function Value({ ...props }: ComponentProps<typeof Progress.Value>) {
    return (
        <Progress.Value
            className="text-caption text-textSec font-medium"
            {...props}
        />
    );
}

export function Track({
    className,
    ...props
}: ComponentProps<typeof Progress.Track>) {
    return (
        <Progress.Track
            className={cn(
                "overflow-hidden h-2 rounded-md shadow-[inset_0_0_0_1px_rgb(229_231_235)]",
                className
            )}
            {...props}
        />
    );
}

export function Indicator({
    ...props
}: ComponentProps<typeof Progress.Indicator>) {
    return (
        <Progress.Indicator
            className="block bg-primary transition-[width] duration-200"
            {...props}
        />
    );
}
